import {
  GetCollaboratorCmSheetDevelopmentIndicatorsResponse,
  UpdateCollaboratorCmSheetDevelopmentIndicatorsRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetDevelopmentIndicatorsService = {
  async get(
    cmSheetId: number,
  ): Promise<GetCollaboratorCmSheetDevelopmentIndicatorsResponse> {
    const response =
      await httpClient.get<GetCollaboratorCmSheetDevelopmentIndicatorsResponse>(
        `v1/cm-sheets/${cmSheetId}/development`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorCmSheetDevelopmentIndicatorsRequest,
  ): Promise<void> {
    await httpClient.put(`v1/cm-sheets/${cmSheetId}/development`, body);
  },
};

export default CmSheetDevelopmentIndicatorsService;
